module.exports = __webpack_public_path__ + "img/mia-foto.7a02b475.png";